import { useNavigation } from '../../contexts/NavigationContext'
import {
  useCreateWhitelistedAddressMutation,
  useGetCompanyWhitelistedAddressesQuery,
} from '../../generated/graphql'
import { AddWhitelistedAddressContent } from '../../components/popover/content/AddWhitelistedAddressContent'
import { MainLayout } from '../../components/layout/MainLayout'
import { useNavigate } from 'react-router-dom'

export function AddWhitelistedAddressPage() {
  const { selectedCompanyId } = useNavigation()
  const [, createAddress] = useCreateWhitelistedAddressMutation()
  const navigate = useNavigate()

  const [{ data: existingAddressesData }] = useGetCompanyWhitelistedAddressesQuery({
    variables: { companyId: selectedCompanyId || '' },
    pause: !selectedCompanyId,
  })

  return (
    <MainLayout
      redirectOnSelect={false}
      hideBack={false}
      contentClassName="mt-0"
      className="h-screen min-h-auto mb-12"
      heightClassName="h-full"
    >
      <AddWhitelistedAddressContent
        onSuccess={() => navigate(-1)}
        existingAddresses={existingAddressesData?.getCompanyWhitelistedAddresses || []}
        onCreateWhitelistedAddress={createAddress}
      />
    </MainLayout>
  )
}
